import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { useTranslate } from 'hooks/useTranslate';

const PlanTableHeader: FC = () => {
  const { t } = useTranslate();

  const invoiceHeaders = [
    { title: 'Nº', width: '5%' },
    { title: t('Plan'), width: '23%' },
    { title: `${t('Cliff')} (${t('meses')})`, width: '9%' },
    { title: `${t('Vesting')} (${t('meses')})`, width: '9%' },
    { title: t('NoOfUnits'), width: '9%' },
    { title: t('Vested'), width: '9%' },
    { title: t('SoldUnits'), width: '9%' },
    { title: t('StrikePriceUnit'), width: '9%' },
    { title: t('SellingPriceUnit'), width: '9%' },
  ];

  return (
    <thead>
      <tr>
        {invoiceHeaders.map((header) => (
          <th className="text-center" style={{ width: header.width }}>
            {header.title}
          </th>
        ))}

        <th className="text-center" style={{ width: '9%' }}>
          {t('Profit')}
          <span
            className="fw-normal"
            style={{
              textTransform: 'none',
            }}
          >
            <em
              className="icon ni ni-info notification-icon ml-1 text-primary"
              id="icon-profit-tooltip"
            />
            <Tooltip
              anchorId="icon-profit-tooltip"
              place="top"
              style={{ maxWidth: '300px' }}
            >
              {t('IncentiveValueDetailsNoStrikePrice')}
            </Tooltip>
          </span>
        </th>
      </tr>
    </thead>
  );
};

export default PlanTableHeader;
